import src from "IMAGE";
export default { src, width: 1153, height: 88, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mPgFVUs5hGWSwfiNEdtBb8XtZZxX1psIoA48U2DVSAAi9gK7B/i5MkAAAAASUVORK5CYII="};
